import { render, staticRenderFns } from "./termsofuse.vue?vue&type=template&id=0e856b7a&scoped=true&"
import script from "./termsofuse.vue?vue&type=script&lang=js&"
export * from "./termsofuse.vue?vue&type=script&lang=js&"
import style0 from "./termsofuse.vue?vue&type=style&index=0&id=0e856b7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e856b7a",
  null
  
)

export default component.exports